import $ from 'jquery';

export default class Slider {
	constructor() {
		const $dots = $('.slick-dots');
		this.baseLineHeight = Number.parseInt($dots.css('line-height'), 10);
		this.baseDotsBottom = Number.parseInt($dots.css('bottom'), 10);
		this.baseSliderMargin = Number.parseInt(
			$('.slick-dotted.slick-slider').css('margin-bottom'),
			10,
		);
	}

	init() {
		this.adjustDotsForMobile();
		this.sliderHeightNewsMobile();

		$(window).scroll(() => {
			this.adjustDotsForMobile();
		});
	}

	adjustDotsForMobile() {
		$('.slick-dots').each((index, element) => {
			const $element = $(element);
			const rowCount = Math.floor($element.height() / this.baseLineHeight);
			$element.css('bottom', `${this.baseDotsBottom * rowCount}px`);
			$element
				.closest('.slick-slider')
				.css('margin-bottom', `${this.baseSliderMargin * rowCount}px`);
		});
	}

	sliderHeightNewsMobile() {
		if ($(window).width() < 992) {
			const newsSlider = $('#main-content .buhck-tile-view');

			newsSlider.each(() => {
				const sliderTileContent = newsSlider.find('.tile-content');
				let highest = 0;

				sliderTileContent.each((idx, tileContent) => {
					const elemHeight = $(tileContent).outerHeight();

					if (elemHeight > highest) {
						highest = elemHeight;
					}
				});

				sliderTileContent.each((idx, tileContent) => {
					$(tileContent).css('height', `${highest}px`);
				});
			});
		}
	}
}
